var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dataLoaded && _vm.ticker
    ? _c(
        "div",
        { class: { "container-max": _vm.width, load: !_vm.dataLoaded } },
        [
          _c(
            "vue-glide",
            { attrs: { perView: 1, autoplay: 5000 } },
            [
              _c("vue-glide-slide", [
                _c("div", { staticClass: "main-rate" }, [
                  _vm.dataLoaded
                    ? _c(
                        "span",
                        { staticClass: "txt" },
                        [
                          parseFloat(_vm.reviews.rating.replace(",", ".")) < 1.5
                            ? [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "reviewWidget::Template.rate1"
                                    )
                                  )
                                ),
                              ]
                            : parseFloat(_vm.reviews.rating.replace(",", ".")) <
                              2.5
                            ? [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "reviewWidget::Template.rate2"
                                    )
                                  )
                                ),
                              ]
                            : parseFloat(_vm.reviews.rating.replace(",", ".")) <
                              3.5
                            ? [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "reviewWidget::Template.rate3"
                                    )
                                  )
                                ),
                              ]
                            : parseFloat(_vm.reviews.rating.replace(",", ".")) <
                              4.5
                            ? [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "reviewWidget::Template.rate4"
                                    )
                                  )
                                ),
                              ]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "reviewWidget::Template.rate5"
                                    )
                                  )
                                ),
                              ],
                        ],
                        2
                      )
                    : _c("span", { staticClass: "txt" }, [
                        _vm._v("\n                    ...\n                "),
                      ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "rating", class: { x: !_vm.hideText } },
                    [
                      _c("span", { staticClass: "blank" }, [
                        _c("i", { staticClass: "fa fa-star" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "fa fa-star" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "fa fa-star" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "fa fa-star" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "fa fa-star" }),
                      ]),
                      _vm._v(" "),
                      _vm.dataLoaded
                        ? _c(
                            "span",
                            {
                              staticClass: "rate",
                              staticStyle: { width: "0%" },
                              style:
                                "width:" +
                                parseFloat(
                                  _vm.reviews.rating.replace(",", ".")
                                ) *
                                  20 +
                                "%",
                            },
                            [
                              _c("i", { staticClass: "fa fa-star" }),
                              _vm._v(" "),
                              _c("i", { staticClass: "fa fa-star" }),
                              _vm._v(" "),
                              _c("i", { staticClass: "fa fa-star" }),
                              _vm._v(" "),
                              _c("i", { staticClass: "fa fa-star" }),
                              _vm._v(" "),
                              _c("i", { staticClass: "fa fa-star" }),
                            ]
                          )
                        : _c(
                            "span",
                            {
                              staticClass: "rate",
                              staticStyle: { width: "0%" },
                            },
                            [
                              _c("i", { staticClass: "fa fa-star" }),
                              _vm._v(" "),
                              _c("i", { staticClass: "fa fa-star" }),
                              _vm._v(" "),
                              _c("i", { staticClass: "fa fa-star" }),
                              _vm._v(" "),
                              _c("i", { staticClass: "fa fa-star" }),
                              _vm._v(" "),
                              _c("i", { staticClass: "fa fa-star" }),
                            ]
                          ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "br" }, [
                    _c("span", [
                      _vm.dataLoaded
                        ? _c("span", { staticClass: "rate-decimal" }, [
                            _vm._v(_vm._s(_vm.reviews.rating)),
                          ])
                        : _c("span", { staticClass: "rate-decimal" }, [
                            _vm._v("..."),
                          ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "txt txt1" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("reviewWidget::Template.summary1")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.dataLoaded
                        ? _c("span", { staticClass: "rate-count" }, [
                            _vm._v(_vm._s(_vm.reviews.userScore)),
                          ])
                        : _c("span", { staticClass: "rate-count" }, [
                            _vm._v("..."),
                          ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "txt txt2" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("reviewWidget::Template.summary2")
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.ticker, function (item, index) {
                return _c("vue-glide-slide", { key: index }, [
                  _c("div", { domProps: { innerHTML: _vm._s(item.text) } }),
                ])
              }),
            ],
            2
          ),
        ],
        1
      )
    : _c(
        "div",
        { class: { "container-max": _vm.width, load: !_vm.dataLoaded } },
        [
          _vm.dataLoaded
            ? _c(
                "span",
                { staticClass: "txt" },
                [
                  parseFloat(_vm.reviews.rating.replace(",", ".")) < 1.5
                    ? [
                        _vm._v(
                          _vm._s(_vm.$translate("reviewWidget::Template.rate1"))
                        ),
                      ]
                    : parseFloat(_vm.reviews.rating.replace(",", ".")) < 2.5
                    ? [
                        _vm._v(
                          _vm._s(_vm.$translate("reviewWidget::Template.rate2"))
                        ),
                      ]
                    : parseFloat(_vm.reviews.rating.replace(",", ".")) < 3.5
                    ? [
                        _vm._v(
                          _vm._s(_vm.$translate("reviewWidget::Template.rate3"))
                        ),
                      ]
                    : parseFloat(_vm.reviews.rating.replace(",", ".")) < 4.5
                    ? [
                        _vm._v(
                          _vm._s(_vm.$translate("reviewWidget::Template.rate4"))
                        ),
                      ]
                    : [
                        _vm._v(
                          _vm._s(_vm.$translate("reviewWidget::Template.rate5"))
                        ),
                      ],
                ],
                2
              )
            : _c("span", { staticClass: "txt" }, [
                _vm._v("\n        ...\n    "),
              ]),
          _vm._v(" "),
          _c("span", { staticClass: "rating", class: { x: !_vm.hideText } }, [
            _vm._m(0),
            _vm._v(" "),
            _vm.dataLoaded
              ? _c(
                  "span",
                  {
                    staticClass: "rate",
                    staticStyle: { width: "0%" },
                    style:
                      "width:" +
                      parseFloat(_vm.reviews.rating.replace(",", ".")) * 20 +
                      "%",
                  },
                  [
                    _c("i", { staticClass: "fa fa-star" }),
                    _vm._v(" "),
                    _c("i", { staticClass: "fa fa-star" }),
                    _vm._v(" "),
                    _c("i", { staticClass: "fa fa-star" }),
                    _vm._v(" "),
                    _c("i", { staticClass: "fa fa-star" }),
                    _vm._v(" "),
                    _c("i", { staticClass: "fa fa-star" }),
                  ]
                )
              : _c(
                  "span",
                  { staticClass: "rate", staticStyle: { width: "0%" } },
                  [
                    _c("i", { staticClass: "fa fa-star" }),
                    _vm._v(" "),
                    _c("i", { staticClass: "fa fa-star" }),
                    _vm._v(" "),
                    _c("i", { staticClass: "fa fa-star" }),
                    _vm._v(" "),
                    _c("i", { staticClass: "fa fa-star" }),
                    _vm._v(" "),
                    _c("i", { staticClass: "fa fa-star" }),
                  ]
                ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "br" }, [
            _c("span", [
              _vm.dataLoaded
                ? _c("span", { staticClass: "rate-decimal" }, [
                    _vm._v(_vm._s(_vm.reviews.rating)),
                  ])
                : _c("span", { staticClass: "rate-decimal" }, [_vm._v("...")]),
              _vm._v(" "),
              _c("span", { staticClass: "txt txt1" }, [
                _vm._v(
                  _vm._s(_vm.$translate("reviewWidget::Template.summary1"))
                ),
              ]),
              _vm._v(" "),
              _vm.dataLoaded
                ? _c("span", { staticClass: "rate-count" }, [
                    _vm._v(_vm._s(_vm.reviews.userScore)),
                  ])
                : _c("span", { staticClass: "rate-count" }, [_vm._v("...")]),
              _vm._v(" "),
              _c("span", { staticClass: "txt txt2" }, [
                _vm._v(
                  _vm._s(_vm.$translate("reviewWidget::Template.summary2"))
                ),
              ]),
            ]),
          ]),
        ]
      )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "blank" }, [
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }